import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BUTTON_STYLES,
  FORM_STYLES,
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
} from "../../styles/componentStyles";
import { useFormik } from "formik";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import LookupsvalidationSchema from "../Validations/AcademicsValidation";
import Staets from "./States";

function LookupModal({ States, open, onClose, lookupsEdit, onSuccess }) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [states, setStates] = useState([]);
  console.log(lookupsEdit);

  // Fetch dropdown data once
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const statesRes = await api.get("/getAllStates");
        setStates(statesRes.data.data);
      } catch (err) {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching dropdown data";
        setError(message);
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdownData();
  }, []);

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      lookup_value: lookupsEdit?.lookupValue || "",
    },

    validationSchema: LookupsvalidationSchema.LookupsvalidationSchema,
    enableReinitialize: true,

    onSubmit: async (values, { resetForm, setSubmitting }) => {
      console.log(lookupsEdit?.id);
      try {
        setSubmitting(true);
        let response;
        // If it's Edit data it will call Update api
        if (lookupsEdit?.id) {
          response = await api.put(
            `/api/v1/lookups/${lookupsEdit?.id}/value`,
            values,
          );
        }

        // Else it's Add data it will call Add api
        // else {
        //   console.log(values);

        //   response = await api.post("/api/v1/subjectCategories", values);
        // }
        // Show success toast
        toast.success(
          `Lookup Value ${lookupsEdit?.id ? "updated" : "added"} successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          },
        );
        onSuccess(response.data.data);
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  return (
    <>
      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {lookupsEdit && Object.keys(lookupsEdit).length > 0
              ? "Update Lookup"
              : "Add Lookup"}
          </Typography>
          <Box sx={FORM_STYLES.container}>
            <TextField
              label="lookup_value"
              name="lookup_value"
              value={formik.values.lookup_value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.lookup_value &&
                Boolean(formik.errors.lookup_value)
              }
              helperText={
                formik.touched.lookup_value && formik.errors.lookup_value
              }
              {...TEXT_FIELD_STYLES.standard}
            />

            <Box
              sx={FORM_STYLES.actions}
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={formik.isSubmitting}
                {...BUTTON_STYLES.primary}
              >
                {formik.isSubmitting ? "Processing..." : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default LookupModal;
